import http from '../jslibs/axios/http';

//内容管理 获取系统推送消息列表
export const messagePushList = data => (http.get('/v1/cms/SystemMessage', data));

//内容管理 添加系统推送消息
export const addMessagePushList = data => (http.post('/v1/cms/SystemMessage', data));

//内容管理 获取系统推送消息详情
export const messagePushDetail = uuid => (http.get(`/v1/cms/SystemMessage/${uuid}`));

//内容管理 删除系统推送消息
export const deleteMessagePush = uuid => (http.delete(`/v1/cms/SystemMessage/${uuid}`));

//内容管理 轮播图列表
export const carouselList = ()=> (http.get('/v1/cms/Carousel'));

//内容管理 轮播图新增
export const addCarousel = data => (http.post('/v1/cms/Carousel', data));

//内容管理 删除轮播图
export const deleteCarousel = uuid => (http.delete(`/v1/cms/Carousel/${uuid}`));

//内容管理 轮播图详情
export const carouselDetail = uuid => (http.get(`/v1/cms/Carousel/${uuid}`));

//内容管理 编辑轮播图
export const editCarousel = data => (http.put(`/v1/cms/Carousel/${data.uuid}`, data));

//内容管理 评论列表
export const commentList = data => (http.get('/v1/cms/Comment', data));

//内容管理 评论显示 隐藏
export const commentHandle = uuid => (http.get(`/v1/cms/Comment/${uuid}`));

//内容管理 评论删除
export const commentDelete = uuid => (http.delete(`/v1/cms/Comment/${uuid}`));